'use client'

import { useState, type InputHTMLAttributes } from 'react'

interface PasswordInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label: string
  error?: string
}

export function PasswordInput({ label, error, id, className, ...props }: PasswordInputProps) {
  const [show, setShow] = useState(false)
  const errorId = id ? `${id}-error` : undefined

  return (
    <div className="flex flex-col gap-1.5">
      <label
        htmlFor={id}
        className="text-sm font-medium text-[var(--color-text-secondary)]"
        style={{ fontFamily: 'var(--font-inter, Inter, sans-serif)' }}
      >
        {label}
      </label>
      <div className="relative">
        <input
          {...props}
          id={id}
          type={show ? 'text' : 'password'}
          aria-invalid={!!error}
          aria-describedby={error ? errorId : undefined}
          className={`h-11 w-full rounded-[var(--radius-md)] border bg-[var(--color-bg-surface)] px-3 pr-16 text-sm text-[var(--color-text-primary)] outline-none transition-colors placeholder:text-[var(--color-text-muted)] focus:border-[var(--color-brand-indigo)] focus:ring-2 focus:ring-[var(--color-brand-indigo)]/25 ${error ? 'border-[var(--color-error)]' : 'border-[var(--color-text-muted)]'} ${className ?? ''}`}
          style={{ fontFamily: 'var(--font-inter, Inter, sans-serif)' }}
        />
        <button
          type="button"
          onClick={() => setShow(!show)}
          aria-label={show ? 'Hide password' : 'Show password'}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-[var(--color-text-muted)] hover:text-[var(--color-text-secondary)]"
          style={{ fontFamily: 'var(--font-inter, Inter, sans-serif)' }}
        >
          {show ? 'Hide' : 'Show'}
        </button>
      </div>
      {error && (
        <p id={errorId} className="text-xs text-[var(--color-error)]" role="alert">
          {error}
        </p>
      )}
    </div>
  )
}
